import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [currentToast, setCurrentToast] = useState(null);
  const [toastQueue, setToastQueue] = useState([]);

  /** `action` ({ label, onClick }) puts one button on the toast - "Join to pick sets  [Join]" (2026-10-26). */
  const showToast = useCallback((message, duration = 4000, { action = null } = {}) => {
    const id = Date.now() + Math.random(); // Unique ID for each toast

    setToastQueue((prev) => [...prev, { id, message, duration, action }]);
  }, []);

  useEffect(() => {
    if (currentToast || toastQueue.length === 0) return;
    const [nextToast, ...remaining] = toastQueue;
    setCurrentToast(nextToast);
    setToastQueue(remaining);
  }, [currentToast, toastQueue]);

  // Dev: window.__priiToast('Joined Portola group') shows one.
  useEffect(() => {
    if (!import.meta.env.DEV) return undefined;
    window.__priiToast = showToast;
    return () => {
      delete window.__priiToast;
    };
  }, [showToast]);

  const hideToast = useCallback((id) => {
    setCurrentToast((prev) => (prev?.id === id ? null : prev));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Above the dock (Sam's pick D, 2026-10-27): over the header it covered the name. */}
      <div className="fixed toast-slot inset-x-0 z-[100] pointer-events-none flex justify-center">
        {currentToast && (
          <div key={currentToast.id} className="pointer-events-auto">
            <Toast
              message={currentToast.message}
              duration={currentToast.duration}
              action={currentToast.action}
              onClose={() => hideToast(currentToast.id)}
            />
          </div>
        )}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
}
